export default __webpack_public_path__ + "static/media/juno-logo.968f52d1.png";